app.factory("MigrationNew", ["$http", "$log",
    function ($http, $log) {
        var Migration = {};

        Migration.list = function (params) {
            return $http.get("/migration/list2", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    program: params.program,
                    subject: params.subject
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Migration.save = function (params) {
            return $http.post('/migration/save2', {
                newSubject: params.newSubject,
                migration: params.migration
            }).then(function (resp) {
                return resp.data;
            })
        };

        Migration.searchProgram = function (book) {
            return $http.get("/migration/search2", {
                params: {
                    book: book
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        return Migration;
    }
]);